var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNoWorksData),expression:"showNoWorksData"}],staticClass:"ui-no-works"},[_c('div',{staticClass:"bg"}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.noDataText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }